import { InputTextField } from '@abbott-components/core';
import { Stack } from '@mui/material';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import ControlState from '../../Shared/controlState';
import ControlPageRoleEngine from './ControlPageRoleEngine';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import formatName from '../formatName';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const { schema } = control;

  const properties = schema?.properties as JSONSchema7Properties;

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 1 }}>
          <InputTextField
            name={formatName(properties['label']?.$id as string)}
            label="Text Label"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 1 }}>
          <InputTextField
            name={formatName(properties['id']?.$id as string)}
            label="ID"
            isDisabled={isReadOnlyView}
          />
        </Stack>
      </Stack>
      <ControlPageRoleEngine
        properties={properties}
        isDisabled={isReadOnlyView}
      />
    </Stack>
  );
};
